module.exports = __webpack_public_path__ + "static/media/photo199.13f206f1.jpg";